import React, { useContext } from "react";
import { FormikContext } from "formik";
import { parsePhoneNumber } from "libphonenumber-js";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import "./PhoneInput.style.css";

const AppPhoneInput = ({
  label,
  showCountryCode = true,
  className = "",
  namePhone = "phone",
  nameCountryCode = "country_code",
  value: externalValue,
  onChange: externalOnChange,
  onBlur: externalOnBlur,
  ...props
}) => {
  // Get Formik context
  const formik = useContext(FormikContext);
  const isFormik = !!formik;

  let value = "";
  if (isFormik) {
    const { values } = formik;
    if (values[namePhone] && values[nameCountryCode]) {
      const cc = values[nameCountryCode].startsWith("+")
        ? values[nameCountryCode]
        : `+${values[nameCountryCode]}`;
      value = cc + values[namePhone];
    }
  } else if (externalValue) {
    value = externalValue;
  }

  const parsePhone = (phone) => {
    if (!phone) return { phone: "", country_code: "" };

    try {
      const parsed = parsePhoneNumber(phone);
      return {
        phone: parsed.nationalNumber,
        country_code: `+${parsed.countryCallingCode}`,
      };
    } catch {
      return { phone: "", country_code: "" };
    }
  };

  const handleChange = (phone) => {
    const parsed = parsePhone(phone);

    if (isFormik) {
      formik.setFieldValue(namePhone, parsed.phone);
      formik.setFieldValue(nameCountryCode, parsed.country_code);
    } else {
      externalOnChange(parsed);
    }
  };

  const handleBlur = () => {
    if (isFormik) {
      formik.setFieldTouched(namePhone, true);
    } else {
      typeof externalOnBlur === "function" && externalOnBlur();
    }
  };

  return (
    <>
      {label && <label htmlFor={props.id || namePhone}>{label}</label>}
      <PhoneInput
        {...props}
        id={props.id || namePhone}
        international
        defaultCountry="US"
        countryCallingCodeEditable={false}
        value={value || undefined}
        onChange={handleChange}
        onBlur={handleBlur}
        className={`${className} ${
          isFormik && formik.touched[namePhone] && formik.errors[namePhone]
            ? "is-invalid"
            : ""
        }`}
      />
      {isFormik && formik.touched[namePhone] && formik.errors[namePhone] && (
        <p className="invalid-feedback d-block">
          {formik.errors[namePhone]}
        </p>
      )}
    </>
  );
};

export default AppPhoneInput;
